import create from 'zustand';
import { UpdateMarketingQueryState } from './interfaces/UpdateQueryState';
import { createCommonMarketingQuerySlice } from './slices/MarketingQuerySlices.ts/CommonMarketingQuerySlice';
import { createUpdateMarketingQuerySlice } from './slices/MarketingQuerySlices.ts/UpdateMarketingQuerySlice';

export const useUpdateMarketingQueryStore = create<UpdateMarketingQueryState>((set) => ({
  ...createCommonMarketingQuerySlice(set),
  ...createUpdateMarketingQuerySlice(set)
}));
